export default [
  {
    path: "/pdfs",
    name: "pdfs",
    component: () => import("@/views/pdfs/index")
  },
  {
    path: "/pdfs/detail",
    name: "pdfDetail",
    component: () => import("@/views/pdfs/detail")
  }
];


// WEBPACK FOOTER //
// ./src/router/pdfs.js